
import Vue from 'vue'
import { VRadioGroup } from 'vuetify/lib'
import JcdcRadioInput from '@/components/jcdc/JcdcRadioInput.vue'
interface item {
  value: [string, number]
  text: string
  disabled?: boolean
}

export default Vue.extend({
  name: 'JcdcRadioGroup',
  components: { JcdcRadioInput, VRadioGroup },
  props: {
    color: { type: String, default: 'primary' },
    itemList: { type: Array as () => Array<item>, default: undefined },
    required: { type: Boolean, default: false },
    errorMessage: { type: String, default: 'Required' },
    dense: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    selected: { type: [String, Boolean, Number], default: null },
    stacked: { type: Boolean, default: false },
    hint: { type: String, default: '' },
    label: { type: String, default: '' },
  },
  data() {
    return {
      rules: [(v) => Boolean(v) || this.errorMessage],
      value: this.selected,
      colorValue: this.color,
    }
  },
  watch: {
    selected() {
      this.value = this.selected
      this.$emit('change', this.value)
    },
  },
  methods: {
    onMousedown() {
      this.readonlyHandler()
    },
    onMouseup() {
      if (this.readonly) {
        this.colorValue = this.color
      }
    },
    readonlyHandler() {
      this.readonly
        ? (this.colorValue = 'error')
        : (this.colorValue = this.color)
    },
  },
})
